// @flow

import ApiObject from './ApiObject';
import ApiConstants from '../constants/ApiConstants';
import Address from './Address';

export default class RestaurantLegalRepresentative extends ApiObject {

  firstName: string = '';

  lastName: string = '';

  birthday: number = 0;

  nationality: string = '';

  countryOfResidence: string = '';

  email: string = '';

  address: Address = new Address();

  identityDocument: string = '';

  postJsonAssignation(data: Object) {
    this.address = new Address();
    this.address.fromJson(data.address);
  }
}
